export default __webpack_public_path__ + "static/media/topbar-icon-settings-1.70da3bab.svg";